import { useDispatch, useSelector } from "react-redux";
import Sidebar from "../../components/sidebar/Sidebar";
import { useNavigate } from "react-router-dom";
import { isLoggedIn, selectToken } from "../login/loginSlice";
import { failedToLoadSupportTickets, loadAllSupportTickets, loadSupportTicketsByBank, loadSupportTicketsByUser, selectSupportTickets, supportTicketLoading } from "./supportTicketsSlice";
import { selectUser } from "../home/userSlice";
import { useEffect } from "react";
import './SupportTickets.css';
import { changeFormActive, changeFormMode, isFormActive } from "../supportTicketForm/supportTicketFormSlice";
import SupportTicketForm from "../supportTicketForm/SupportTicketForm";
import SupportTicketList from "../../components/supportTicketList/SupportTicketList";
import SearchBar from "../searchBar/SearchBar";
import { changeSearchMode, changeSearchTarget, changeSearchTargetOptions, selectFilters, selectSearchMode } from "../searchBar/searchBarSlice";
import Filter from "../../components/filter/Filter";
import { loadAllUsers } from "../manageUsers/manageUsersSlice";

export default function SupportTickets() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const token = useSelector(selectToken);
    const loggedIn = useSelector(isLoggedIn);
    const userInfo = useSelector(selectUser);
    const userRole = userInfo.userRole;
    const username = userInfo.username;
    const bankId = userInfo.bankId;

    const supportTickets = useSelector(selectSupportTickets);
    const searchFilters = useSelector(selectFilters);
    const supportFilters = searchFilters.filter(filter => filter.searchMode === 'support');
    const searchMode = useSelector(selectSearchMode);
    const userSupportTickets = supportTickets.filter(supportTicket => supportTicket.username === username);
    const bankSupportTickets = supportTickets.filter(supportTicket => supportTicket.username !== username);
    const adminSupportTickets = supportTickets.filter(supportTicket => supportTicket.supportLevel === '2' && supportTicket.username !== username);
    const loadingSupportTickets = useSelector(supportTicketLoading);
    const loadSupportTicketsFailed = useSelector(failedToLoadSupportTickets);
    const createTicketFormActive = useSelector(isFormActive);

    useEffect(() => {
        if (!loggedIn) {
            navigate(`../login`);
        }
    }, [loggedIn, navigate])

    useEffect(() => {
        if (!supportTickets.length) {
            if (userRole === 'SUPERADMIN') {
                dispatch(loadAllSupportTickets(token))
            } else if (userRole === 'ADMIN') {
                dispatch(loadSupportTicketsByBank({bankId, token}));
            } else if (userRole === 'TELLER') {
                dispatch(loadSupportTicketsByUser({username, token}));
            } else {
                dispatch(loadSupportTicketsByUser({username, token}));
            }
            
        }
    }, [bankId, token, userRole, supportTickets, loadSupportTicketsFailed, username, dispatch])

    useEffect(() => {
        if (userRole === 'SUPERADMIN') {
            dispatch(loadAllUsers(token));
        }
    }, [dispatch, token, userRole])

    useEffect(() => {
        if (searchMode !== 'support') {
            dispatch(changeSearchTargetOptions(['Support Ticket Id', 'Type', 'Title', 'Severity', 'Created By', 'Bank Id', 'Status']));
            dispatch(changeSearchMode('support'));
            dispatch(changeSearchTarget('Support Ticket Id'));
        }
    }, [searchMode, dispatch]);

    const handleCreateTicketClick = () => {
        dispatch(changeFormActive(true));
        dispatch(changeFormMode('create'));
    }

    
    return (
        <main>
            <Sidebar />
            <section className="support-tickets">
                <h2>Support Tickets</h2>
                <div className="support-header">
                    <SearchBar />    
                    <button onClick={handleCreateTicketClick}>Create Support Ticket</button>
                </div>
                <div className="filters">
                    {supportFilters.map(filter => <Filter filter={filter}/>)}
                </div>
                {loadingSupportTickets ? <h2>Loading Support Tickets</h2> : (
                    <div>
                        <h3>My Support Tickets</h3>
                        <SupportTicketList supportTickets={userSupportTickets} />
                        {userRole === 'SUPERADMIN' ? <h3>Admin Support Tickets</h3> : ""}
                        {userRole === 'SUPERADMIN' ? <SupportTicketList supportTickets={adminSupportTickets}/> : ""}
                        {userRole === 'ADMIN' ? <h3>User Support Tickets</h3> : ""}
                        {userRole === 'ADMIN' ? <SupportTicketList supportTickets={bankSupportTickets}/> : ""}
                    </div>
                )}
            </section>
            {createTicketFormActive ? <SupportTicketForm /> : ""}
        </main>
    )
}